import { UAItem } from "@/interfaces/CardItem";

import { getCardData } from "@/lib/games/unionArena/getCardDataLocal";

export function sortCards(a: UAItem, b: UAItem) {
  // cost
  if (b.energy_cost !== a.energy_cost) {
    let acost;
    let bcost;
    if (
      b.energy_cost === undefined ||
      b.energy_cost === null ||
      b.energy_cost === ""
    ) {
      bcost = 0;
    } else {
      bcost = parseInt(b.energy_cost.toString());
    }
    if (
      a.energy_cost === undefined ||
      a.energy_cost === null ||
      a.energy_cost === ""
    ) {
      acost = 0;
    } else {
      acost = parseInt(a.energy_cost.toString());
    }
    // handle special cases where cost is "-" or 0
    if (acost - bcost !== 0) {
      return acost - bcost; // Compare as numbers
    }
  }

  // color
  if (b.color !== a.color) {
    const colorOrder: string[] = ["Red", "Blue", "Yellow", "Green", "Purple"];
    const colorAIndex = colorOrder.indexOf(a.color);
    const colorBIndex = colorOrder.indexOf(b.color);
    return colorAIndex - colorBIndex;
  }

  // type
  if (b.card_type !== a.card_type) {
    const typeOrder: string[] = ["Character", "Event", "Site", "Action Point"];
    const typeAIndex = typeOrder.indexOf(a.card_type);
    const typeBIndex = typeOrder.indexOf(b.card_type);
    return typeAIndex - typeBIndex;
  }

  // rarity
  // make P2 appear after P1 etc.

  // power
  if (
    b.battle_power !== undefined &&
    a.battle_power !== undefined &&
    b.battle_power !== a.battle_power
  ) {
    // Handle empty string case
    if (a.battle_power === "") return -1;
    if (b.battle_power === "") return 1;

    // Extract number and modifier
    const getBattlePowerValue = (bp: string) => {
      const num = parseInt(bp.replace(/[^0-9]/g, ""));
      const modifier = bp.replace(/[0-9]/g, "");

      // Return an array with [number, modifierWeight]
      // modifierWeight: 0 for no modifier, 1 for -, 2 for ±, 3 for +
      let modifierWeight = 0;
      if (modifier === "-") modifierWeight = 1;
      else if (modifier === "±") modifierWeight = 2;
      else if (modifier === "+") modifierWeight = 3;

      return [num, modifierWeight];
    };

    const [aNum, aMod] = getBattlePowerValue(a.battle_power);
    const [bNum, bMod] = getBattlePowerValue(b.battle_power);

    // First compare the numbers
    if (aNum !== bNum) {
      return aNum - bNum;
    }

    // If numbers are equal, compare by modifier
    return aMod - bMod;
  }

  // this slows it down a lot
  // compare name of base rarity card. This allows for cards to be grouped by their number_id
  //   let aName = a.name;
  //   if (a.id.includes("_p")) {
  //     const baseCardA = getCardData(a.number)?.name;
  //     aName = baseCardA || a.name;
  //   }
  //   let bName = b.name;
  //   if (a.id.includes("_p")) {
  //     const baseCardB = getCardData(a.number)?.name;
  //     bName = baseCardB || b.name;
  //   }

  //   if (aName !== bName) {
  //     return aName.localeCompare(bName);
  //   }

  // number
  //   if (a.number !== b.number) {
  //     return a.number.localeCompare(b.number);
  //   }

  return a.id.localeCompare(b.id);
}
